import VExportPaymentBaseItem from "../Domain/VExportPaymentBaseItem.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import ExportPaymentSearchParams from "../Contents/Operations/PaymentExport/AllExport/ExportPaymentSearchParams";

export default class VExportPaymentService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();

    let url = "/api/ExportPayment/GetBySearchParams/?";

    const searchParams = new SearchParams(searchItem, ExportPaymentSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;

    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new VExportPaymentBaseItem(item));
    }

    return [];
  }

  static GetById(id) {
    const authService = AuthService.getInstance();
    const url = `/api/Export/GetById/${id}?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static Void(item) {
    return VExportPaymentService.ActionByCommand("Void", item.Ids, item.Reason, item.Surcharge);
  }

  static VoidAndReissue(item) {
    return VExportPaymentService.ActionByCommand("VoidAndReissue", item.Ids, item.Reason, item.Surcharge);
  }

  static VoidAndSuppress(item) {
    return VExportPaymentService.ActionByCommand("VoidAndSuppress", item.Ids, item.Reason, item.Surcharge);
  }

  static Reconcile(item) {
    const authService = AuthService.getInstance();
    const url = "/api/Export/ReconcileExportPayment";
    const itemJson = JSON.stringify(item);
    return authService.CallBackendFunctionPut(url, itemJson);
  }

  static ActionByCommand(command, selectedIds, reason, surcharge) {
    const idsWithReason = {
      SelectedIds: selectedIds,
      Reason: reason,
      Surcharge: surcharge,
    };
    const authService = AuthService.getInstance();
    const url = `/api/Export/ActionByCommand/${command}`;
    const idsWithReasonJson = JSON.stringify(idsWithReason);
    return authService.CallBackendFunctionPut(url, idsWithReasonJson);
  }

  static ResendEvaluatorStatement(selected) {
    return VExportPaymentService.ActionByCommand("ResendEvaluatorStatement", selected, "", "");
  }
}
